import { FETCH_CURRENT_COUNTRY, FETCH_CURRENT_COUNTRY_SUCCESS, SESSION_EXPIRED } from '../actions/types';

const utilities = (state = { status: undefined, currentCountry: '', sessionExpired: {}, courseId: '', headerStyle: false, videoBar: {}, showHamburger: undefined }, action) => {
  switch (action.type) {
    case FETCH_CURRENT_COUNTRY:
      return Object.assign({}, state, { status: 'fetching' });
    case FETCH_CURRENT_COUNTRY_SUCCESS:
      return Object.assign({}, state, { status: 'success', currentCountry: action.data });
    case SESSION_EXPIRED:
      return Object.assign({}, state, { status: 'expired', sessionExpired: action.data });
    default:
      return state;
  }
};

export default utilities;
